import { useState, useEffect } from 'react';
import { getESM2to1StocksFilterOptions } from '@/lib/api/esm2to1StocksApi';
import { watchlistApi } from '@/lib/api/watchlistApi';
import { ESM2to1StocksFilterOptions } from '@/types/esm2to1Stocks';

export function useESM2to1StocksFilterOptions() {
  const [filterOptions, setFilterOptions] = useState<ESM2to1StocksFilterOptions | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function fetchFilterOptions() {
      try {
        setLoading(true);
        setError(null);

        // Get base filter options (now synchronous) and fetch watchlists
        const options = getESM2to1StocksFilterOptions();
        const watchlistsResponse = await watchlistApi.listWatchlists();

        const watchlists = watchlistsResponse.watchlists.map(w => ({
          id: w.id,
          name: w.name,
          number_of_stocks: (w as typeof w & { number_of_stocks?: number }).number_of_stocks || 0,
          watchlist_type: (w as typeof w & { watchlist_type?: 'default' | 'system_generated' }).watchlist_type || 'default'
        }));

        setFilterOptions({
          ...options,
          watchlists
        });
        setError(null);
      } catch (err) {
        console.error('Failed to load filter options:', err);
        // Fallback to base options without watchlists
        const options = getESM2to1StocksFilterOptions();
        setFilterOptions({
          ...options,
          watchlists: []
        });
        setError('Failed to load watchlists, but other filters are available');
      } finally {
        setLoading(false);
      }
    }

    fetchFilterOptions();
  }, []);

  return {
    filterOptions,
    loading,
    error,
  };
}
